import { Svg, Path } from "react-native-svg";

const RightAngle = (props) => (
  <Svg height={12} width={13} viewBox="0 0 13 12" fill="none" {...props}>
    <Path d="M1.12793 0.712891V11.498H12.0186" stroke="#CECDD0" />
  </Svg>
);

export default RightAngle;
